import React from "react";

const DashboardIcon = ({ iconClass, color }) => {
  return (
    <svg
      width={20}
      height={21}
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={iconClass}
      preserveAspectRatio="xMidYMid meet"
    >
      <path
        d="M18.3333 9.58341V3.91675C18.3333 2.66675 17.8 2.16675 16.475 2.16675H13.1083C11.7833 2.16675 11.25 2.66675 11.25 3.91675V9.58341C11.25 10.8334 11.7833 11.3334 13.1083 11.3334H16.475C17.8 11.3334 18.3333 10.8334 18.3333 9.58341Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.3333 17.0833V15.5833C18.3333 14.3333 17.8 13.8333 16.475 13.8333H13.1083C11.7833 13.8333 11.25 14.3333 11.25 15.5833V17.0833C11.25 18.3333 11.7833 18.8333 13.1083 18.8333H16.475C17.8 18.8333 18.3333 18.3333 18.3333 17.0833Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.74984 11.4167V17.0834C8.74984 18.3334 8.2165 18.8334 6.8915 18.8334H3.52484C2.19984 18.8334 1.6665 18.3334 1.6665 17.0834V11.4167C1.6665 10.1667 2.19984 9.66675 3.52484 9.66675H6.8915C8.2165 9.66675 8.74984 10.1667 8.74984 11.4167Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.74984 3.91675V5.41675C8.74984 6.66675 8.2165 7.16675 6.8915 7.16675H3.52484C2.19984 7.16675 1.6665 6.66675 1.6665 5.41675V3.91675C1.6665 2.66675 2.19984 2.16675 3.52484 2.16675H6.8915C8.2165 2.16675 8.74984 2.66675 8.74984 3.91675Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default DashboardIcon;
